import {
    Heading,
    Button,
    View,
    Flex,
} from "@aws-amplify/ui-react";
import { API, Auth } from "aws-amplify";

export function Analytics({
    balance,
    updateBalance,
    subscription,
    clientData,
}) {
    // New function to send email silently
    async function handleAnalyticsButtonClick(buttonName) {
        try {
            const user = await Auth.currentAuthenticatedUser();
            const subject = `Analytics button "${buttonName}" clicked by ${
                clientData?.email || "unknown"
            }`;
            const body = [
                `Analytics button "${buttonName}" clicked by ${clientData?.email || "unknown"}`,
                `subscriptionPlan: ${clientData?.subscriptionPlan || "N/A"}`,
                `payments: ${clientData?.payments || "N/A"}`,
                `fiatBalance: ${clientData?.fiatBalance || 0}`,
                `subscriptionId: ${clientData?.subscriptionId || "N/A"}`,
            ].join("\n");

            const request = {
                headers: {
                    Authorization: `${user.signInUserSession.idToken.jwtToken}`,
                },
                body: { subject, body },
            };
            await API.post("gcAPI", "/send-email", request);
        } catch (error) {
            // Silent catch
        }
    }

    return (
        <>
            <View align="center">
                <View maxWidth="1000px" align="left">
                    <Heading
                        level={3}
                        fontWeight={"bold"}
                        textAlign="center"
                        color={"#414c5a"}
                        style={{ lineHeight: "1.5" }}
                    >
                        Analytics for your
                        <br />
                        LinkedIn profile
                        <br />
                        <br />
                    </Heading>

                    <Flex
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        marginBottom="20px"
                    >
                        <Button
                            variation="primary"
                            size="large"
                            style={{ marginBottom: "10px", padding: "20px 40px" }}
                            onClick={() => handleAnalyticsButtonClick("Track & Grow SSI")}
                        >
                            Track & Grow SSI
                        </Button>
                        <Button
                            variation="primary"
                            size="large"
                            style={{ marginBottom: "10px", padding: "20px 40px" }}
                            onClick={() => handleAnalyticsButtonClick("Track profiles")}
                        >
                            Track profiles
                        </Button>
                        <Button
                            variation="primary"
                            size="large"
                            style={{ marginBottom: "10px", padding: "20px 40px" }}
                            onClick={() => handleAnalyticsButtonClick("Track posts")}
                        >
                            Track posts
                        </Button>
                        <Button
                            variation="primary"
                            size="large"
                            style={{ marginBottom: "10px", padding: "20px 40px" }}
                            onClick={() => handleAnalyticsButtonClick("Track trends")}
                        >
                            Track trends
                        </Button>
                        <Button
                            variation="primary"
                            size="large"
                            style={{ marginBottom: "10px", padding: "20px 40px" }}
                            onClick={() => handleAnalyticsButtonClick("Coming Soon!")}
                        >
                            Coming Soon!
                        </Button>
                        <br />
                    </Flex>
                </View>
            </View>
        </>
    );
}
